import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'typed-redux-saga';

import { cloudApi } from '../../../shared/helpers/transport';
import { RecipientFetchingStatus } from '../features/fetching/types';
import { addArtifactRecipients, ArtifactType, setArtifactRecipientFetchingStatus } from '../features/sidebar/slice';
import { convertRecipient } from '../helpers/convert-recipient';

const FETCH_RECIPIENTS_LIMIT = 1000;
export function* fetchSummarizationRecipientSaga({
    payload: { artifactId, confShortUrlId, sessionId, offset, artifactType },
}: PayloadAction<{
    confShortUrlId: string;
    sessionId: string;
    artifactId: string;
    offset: number;
    artifactType: ArtifactType;
}>) {
    yield* put(
        setArtifactRecipientFetchingStatus({ artifactId, artifactType, status: RecipientFetchingStatus.FETCHING })
    );
    try {
        const response = yield* call(
            [cloudApi, cloudApi.getArtifactRecipients],
            confShortUrlId,
            sessionId,
            artifactId,
            artifactType,
            offset,
            FETCH_RECIPIENTS_LIMIT
        );
        yield* put(
            addArtifactRecipients({ artifactId, artifactType, recipients: response.items.map(convertRecipient) })
        );
    } catch {
        yield* put(
            setArtifactRecipientFetchingStatus({
                artifactId,
                artifactType,
                status: RecipientFetchingStatus.NOT_FETCHED,
            })
        );
        return;
    }
    yield* put(
        setArtifactRecipientFetchingStatus({ artifactId, artifactType, status: RecipientFetchingStatus.FETCHED })
    );
}
